import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { faExclamationTriangle, IconDefinition, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from '../../services/notification.service';
import { NotificationType } from '../../models/notification-type';
import { NotificationMessage } from '../../models/notification-message';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-massage',
  templateUrl: './notification-massage.component.html',
  styleUrls: ['./notification-massage.component.css']
})
export class NotificationMassageComponent implements OnInit, OnDestroy {

  faExclamationTriangle = faExclamationTriangle;
  faInfoCircle = faInfoCircle;

  private _navigateSubscription = new Subscription();

  constructor(
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit(): void {
    this._navigateSubscription = this.notificationService.navigateToMessage.subscribe(_ => {
      this.scrollToMessage();
    });
  }

  ngOnDestroy(): void {
    if (this._navigateSubscription) {
      this._navigateSubscription.unsubscribe();
      this._navigateSubscription = null;
    }
  }

  scrollToMessage(): void {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  get massages(): NotificationMessage[] {
    return this.notificationService.messages;
  }

  getClassName(notificationMessage: NotificationMessage): string {
    switch (notificationMessage.type) {
      case NotificationType.Error:
        return 'error-sign';
      case NotificationType.Warning:
        return 'warning-sign';
      case NotificationType.Success:
      default:
        return 'success-sign';
    }
  }

  getIcon(notificationMessage: NotificationMessage): IconDefinition {
    switch (notificationMessage.type) {
      case NotificationType.Error:
        return this.faExclamationTriangle;
      case NotificationType.Warning:
        return this.faExclamationTriangle;
      case NotificationType.Success:
      default:
        return this.faInfoCircle;
    }
  }
}
